import { useEffect, useRef, useState } from 'react';

import { ConvertedImageRaw } from '../../../../../core/types';

import { getSelectedNode, getSelectedNodeImage } from '../../../../../core';
import { ChallengeSaveError } from '../../../../../types';

export const useSelectedNode = () => {
  const loadedNodeId = useRef<string | undefined>(undefined);
  const [selectedNode, setSelectedNode] = useState<Pick<
    SceneNode,
    'id' | 'name' | 'type'
  > | null>(null);

  const [selectedNodeImage, setSelectedNodeImage] = useState<
    ConvertedImageRaw | ChallengeSaveError | null
  >(null);

  const readSelectedNode = async () => {
    const selected = await getSelectedNode();

    if (!selected) return;

    if (!loadedNodeId.current || loadedNodeId.current !== selected.id) {
      const selectedImage = await getSelectedNodeImage();

      setSelectedNode(selected);
      setSelectedNodeImage(selectedImage);
      loadedNodeId.current = selected.id;
    }
  };

  useEffect(() => {
    readSelectedNode();

    const interval = setInterval(() => {
      readSelectedNode();
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return { selectedNode, selectedNodeImage };
};
